import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { ReactComponent as SvgError } from 'public/assets/icons/error.svg';
import classNames from 'classnames';
import styles from './styles.module.scss';

export interface IProps {
  className?: string;
  children: string;
}

export const ErrorBlock = (
  { className, children }: IProps,
) => (
  <BoxWithShadow className={classNames(styles.box, className)}>
    <SvgError />
    {children}
  </BoxWithShadow>
);
